import DocsSharedWithPresta from './DocsSharedWithPresta'

const ViewDocs = ({ record }) => {
  return <>{record?.ticket_id && <DocsSharedWithPresta record={record} />}</>
}
export default ViewDocs
